<template>
  <div class="flex flex-wrap" v-if="plans">
    <div class="w-1/2 pr-8">
      <div class="border-4 rounded-lg shadow-lg">

        <div class="p-4 text-xl font-semibold uppercase text-center border-b-4 bg-gray-100 flex items-center justify-center">
          <img src="https://cdn2.iconfinder.com/data/icons/vivid/48/briefcase-256.png" class="inline w-8 mr-3 mt-1" />
          {{ plans.standard.nickname}}
        </div>

        <div class="p-4 text-center text-lg text-gray-800 border-b-4">
          ${{ plans.standard.amount / 100 }} AUD / month including GST
        </div>

        <div class="p-4 text-base border-b overflow-hidden">
          <img src="/static/img/icons/icons8-asterisk-filled-50.png" class="float-left w-3 mt-2" />
          <div class="ml-6">
            Eliminate meetings with your clients by completely automating your-fact find and document collection processes, 
            saving <span class="font-black">3 to 5 hours</span> of work per client.
          </div>
        </div>

        <div class="p-4 text-base border-b overflow-hidden">
          <img src="/static/img/icons/icons8-asterisk-filled-50.png" class="float-left w-3 mt-2" />
          <div class="ml-6">
            Have the information you need before meeting the client to discuss.  
          </div>
        </div>

        <div class="p-4 text-base border-b overflow-hidden">
          <img src="/static/img/icons/icons8-asterisk-filled-50.png" class="float-left w-3 mt-2" />
          <div class="ml-6">
            Allow clients to directly enter their information in secure &amp; user-friendly online forms.
          </div>
        </div>

        <div class="p-4 text-base border-b overflow-hidden">
          <img src="/static/img/icons/icons8-asterisk-filled-50.png" class="float-left w-3 mt-2" />
          <div class="ml-6">
            Requeust specific documents you require and have your clients to upload them directly to {{ getAppName }}
            via our secure file access portal.
          </div>
        </div>

        <div class="p-4 text-base border-b overflow-hidden">
          <img src="/static/img/icons/icons8-asterisk-filled-50.png" class="float-left w-3 mt-2" />
          <div class="ml-6">
            Uploaded documents are automatically renamed according to type for easy finding and organization.
          </div>
        </div>

        <div class="p-4 text-base border-b overflow-hidden">
          <img src="/static/img/icons/icons8-asterisk-filled-50.png" class="float-left w-3 mt-2" />
          <div class="ml-6">
            Documents can be downloaded as a zip file to your PC, Dropbox, OneDrive or other storage location.
          </div>
        </div>

        <div class="p-4 text-base border-b overflow-hidden">
          <img src="/static/img/icons/icons8-asterisk-filled-50.png" class="float-left w-3 mt-2" />
          <div class="ml-6">
            Simplifies annual reviews because clients don’t need to re-enter their data.
          </div>
        </div>

        <div class="p-4 text-base border-b overflow-hidden">
          <img src="/static/img/icons/icons8-asterisk-filled-50.png" class="float-left w-3 mt-2" />
          <div class="ml-6">
            Compiles client information into a single PDF.
          </div>
        </div>

        <div class="p-4 text-base border-b overflow-hidden">
          <img src="/static/img/icons/icons8-asterisk-filled-50.png" class="float-left w-3 mt-2" />
          <div class="ml-6">
            Personalize your {{ getAppName }} account with your own logo, colours, profile images and contact details so that it 
            looks like your website to clients.
          </div>
        </div>

        <div class="p-4 text-base border-b overflow-hidden">
          <img src="/static/img/icons/icons8-asterisk-filled-50.png" class="float-left w-3 mt-2" />
          <div class="ml-6">
            Add your own personalized video to introduce yourself to clients.
          </div>
        </div>

        <div class="p-4 text-base border-b overflow-hidden">
          <img src="/static/img/icons/icons8-asterisk-filled-50.png" class="float-left w-3 mt-2" />
          <div class="ml-6">
            Automatically attach your FSG and other documents to client emails.
          </div>
        </div>

        <div class="p-4 text-base border-b overflow-hidden">
          <template v-if="activeSubscription != null">
            <template v-if="activeSubscription.stripe_plan == plans.standard.id">
              <template v-if="activeSubscription.on_grace_period">
                <a href="#" 
                  class="subscription-button"
                  v-on:click.prevent="resumeSubscription()">Resume subscription</a>
              </template>
              <template v-else>
                <div class="bg-gray-600 text-white w-full text-center py-4 text-sm font-semibold rounded">
                  This is your current plan
                </div>
              </template>              
            </template>

<!--            <template v-else>-->
<!--              <a href="#" -->
<!--                class="subscription-button"-->
<!--                v-on:click.prevent="switchSubscription(plans.standard)">Switch to Standard Plan</a>-->
<!--            </template>-->
          </template>

          <template v-else>
            <a href="#" 
              class="subscription-button"
              v-on:click.prevent="subscribe(plans.standard)">Start Now</a>
          </template>
        </div>
      </div>
    </div>

    <div class="w-1/2 pl-8">
      <div class="border-4 rounded-lg shadow-lg">

        <div class="p-4 text-xl font-semibold uppercase text-center border-b-4 bg-gray-100">
          <img src="https://cdn2.iconfinder.com/data/icons/vivid/48/badge-256.png" class="inline w-8 mr-3" />
          {{ plans.pro.nickname }}
        </div>

        <div class="p-4 text-center text-lg text-gray-800 border-b-4">
          ${{ plans.pro.amount / 100 }} AUD / month including GST
        </div>

        <div class="p-4 text-base border-b overflow-hidden">
          <img src="/static/img/icons/icons8-asterisk-filled-50.png" class="float-left w-3 mt-2" />
          <div class="ml-6">
            Includes all features from the Standard Plan, PLUS
          </div>
        </div>

        <div class="p-4 text-base border-b overflow-hidden">
          <img src="/static/img/icons/icons8-asterisk-filled-50.png" class="float-left w-3 mt-2" />
          <div class="ml-6">
            Integration with Optimo Pathfinder - Upload your data directly to Optimo with single click of a button.
          </div>
        </div>

        <div class="p-4 text-base border-b overflow-hidden">
          <img src="/static/img/icons/icons8-asterisk-filled-50.png" class="float-left w-3 mt-2" />
          <div class="ml-6">
            Allows you to create strategies for clients without data entry.
          </div>
        </div>

        <div class="p-4 text-base border-b overflow-hidden">
          <template v-if="activeSubscription != null">
            <template v-if="activeSubscription.stripe_plan == plans.pro.id">
              <template v-if="activeSubscription.on_grace_period">
                <a href="#" class="subscription-button"
                  v-on:click.prevent="resumeSubscription()">Resume subscription</a>
              </template>
              <template v-else>
                <div class="bg-gray-600 text-white w-full text-center py-4 text-sm font-semibold rounded">
                  This is your current plan
                </div>
              </template>        
            </template>

<!--            <template v-else>-->
<!--              <a href="#" -->
<!--                class="subscription-button"-->
<!--                v-on:click.prevent="switchSubscription(plans.pro)">Switch to Pro Plan</a>-->
<!--            </template>-->
          </template>

          <template v-else>
            <a href="#" 
              class="subscription-button"
              v-on:click.prevent="subscribe(plans.pro)">Start Now</a>
          </template>
        </div>
      </div>


      <template>
        <div>
          <vue-stripe-checkout
            ref="checkoutRef"       
            :name="name"
            :description="description"
            :panel-label="buttonLabel"
            :currency="currency"
            :amount="amount"
            :allow-remember-me="false"
            :billing-address="false"   
            :email="plannerEmail"
            @done="done"
            @opened="opened"
            @closed="closed"
            @canceled="canceled"
          ></vue-stripe-checkout>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import { EventBus } from '@/shared/event-bus';
  import axios        from 'axios'

  export default {
    
    data() {
      return {
        plans     : null,
        selectedPlanId  : '',
        selectedPlanName: '',

        /** vars to render checkout model */
        // image      : 'https://i.imgur.com/HhqxVCW.jpg', // usage -> :image="image"
        name       : "Plannerpad",
        description: "Thank you for subscribing.",    
        buttonLabel: "Subscribe {{amount}}",
        currency   : 'AUD',
        amount     : 0
      }
    },

    props : {
      activeSubscription : {
        type    : Object | Array,
        required: false
      },

      plannerEmail: {
        type : String,
        required: false
      }
    },

    created() {   
      this.getPlans()
    },

    methods : {

      getPlans() {
        this.showLoader('Loading plans...')
        this.apiGet({}, 'plan/list', (plans) => {
          this.plans = plans
          this.hideLoader()
        })
      },
      
    
      async subscribe(stripePlan) {
        // this.description      += stripePlan.nickname + ' package'
        // this.amount           = stripePlan.amount
        this.selectedPlanId   = stripePlan.id
        this.selectedPlanName = stripePlan.nickname
      
        this.initiate()
      },

      async initiate() {
        const { token, args } = await this.$refs.checkoutRef.open()
      },

      done ({token, args}) {
        this.showLoader('Subscribing...')

        axios.post(process.env.VUE_APP_API_URL + '/api/plan/subscribe', {
          stripeToken: token.id,
          planName   : this.selectedPlanName,
          planId     : this.selectedPlanId          
        }, {
          headers: {
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        }).then(response => {
          this.hideLoader()
          EventBus.$emit('get-subscription')
          EventBus.$emit('notification-event', {
            'type'   : 'success',
            'message': 'Successfully subscribed..'
          })
        }).catch(e => {
          this.hideLoader()
          EventBus.$emit('notification-event', {
            'type'   : 'error',
            'message': 'Unable to subscribe..Please ensure you have entered correct card details.'
          })
        })
      },

      opened () {
       // do stuff 
      },   

      closed () {
        // do stuff 
      },

      canceled () {
        // do stuff 
      },

      switchSubscription(stripePlan) {
        alert('WIP'); return;
      },

      resumeSubscription() {
        this.showLoader('Resuming...')
        this.apiPost({
          planName: this.activeSubscription.name
        }, 'plan/resume', () => {
          this.hideLoader()
          EventBus.$emit('get-subscription')
          EventBus.$emit('notification-event', {
            'type'   : 'success',
            'message': 'Successfully resumed.'
          });      
        })
      }
    }
  }
</script>

<style scoped>
  .subscription-button {
    @apply w-full block text-sm font-semibold no-underline text-white bg-blue-500 p-4 text-center rounded;
  }

  .subscription-button:hover {
    @apply bg-blue-600 
  }
</style>